import { render, staticRenderFns } from "./GridBoard.vue?vue&type=template&id=eae5ea84&scoped=true&"
import script from "./GridBoard.vue?vue&type=script&lang=js&"
export * from "./GridBoard.vue?vue&type=script&lang=js&"
import style0 from "./GridBoard.vue?vue&type=style&index=0&id=eae5ea84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae5ea84",
  null
  
)

export default component.exports